import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { User } from "@supabase/supabase-js";
import { LogOut } from "lucide-react";
import { CreditDisplay } from "@/components/features/payment/CreditDisplay";

const Header = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const getSession = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      setUser(session?.user ?? null);
    };

    getSession();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate("/");
  };

  return (
    <header className="fixed left-0 right-0 top-0 z-50">
      <div className="container mx-auto px-6 pt-4">
        <div className="panel-glass rounded-full border border-white/70 px-4 py-3 shadow-card md:px-6">
          <div className="flex items-center justify-between gap-4">
            <button
              type="button"
              onClick={() => navigate("/")}
              className="flex items-center space-x-3 transition-opacity hover:opacity-90"
              aria-label="Retour à l'accueil"
            >
              <div className="flex h-10 w-10 items-center justify-center rounded-full gradient-brand shadow-glow">
                <div className="h-3 w-3 rounded-full bg-white/95" />
              </div>
              <span className="hidden font-display text-lg leading-none text-foreground sm:inline sm:text-xl">Ma Photo en Tableau</span>
            </button>

            <div className="flex items-center justify-end gap-2 sm:gap-3">
              {user ? (
                <>
                  <div className="rounded-full border border-white/70 bg-white/60 px-2 py-1 shadow-sm backdrop-blur-sm">
                    <CreditDisplay className="flex-shrink-0" />
                  </div>
                  <Button
                    variant="premium"
                    className="rounded-full px-4 shadow-lg shadow-primary/20 sm:px-6"
                    onClick={() => navigate("/create")}
                  >
                    <span className="sm:hidden">Créer</span>
                    <span className="hidden sm:inline">Créer mon œuvre</span>
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    className="rounded-full border-white/70 bg-white/60 text-foreground/70 hover:bg-white hover:text-foreground"
                    onClick={handleSignOut}
                    aria-label="Se déconnecter"
                  >
                    <LogOut className="h-4 w-4" />
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outline"
                    className="hidden rounded-full border-foreground/10 bg-white/50 sm:inline-flex"
                    onClick={() => navigate("/auth")}
                  >
                    Connexion
                  </Button>
                  <Button variant="premium" className="rounded-full" onClick={() => navigate("/auth?tab=signup")}>
                    Créer mon compte
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
